import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HomeService } from '../../../services/home.service';
import { FiltroSegmentacaoService } from '../../../state-service/filtro-segmentacao.service';
import { SwiperContainer } from 'swiper/element';
import { SaldoUtil } from '../../../infra/saldo-util';
import { SaldoService } from '../../../services/saldo.service';
import { EnumPermissao } from '../../../enums/permissoes.enum';
import { PermissaoService } from '../../../services/permissao.service';
import { AuthService } from '../../../services/auth.service';
import { ChaveValor } from '../../../interfaces/segmentacao/chave-valor.interface';
import { Novidade } from '../../../interfaces/novidade/novidade.interface';
import { FiltroSegmentacao } from '../../../interfaces/segmentacao/filtro-segmentacao.interface';
declare const bootstrap: any;

@Component({
  selector: 'app-home',
  standalone: false,
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  constructor(
    private homeService: HomeService,
    private router: Router,
    private toastr: ToastrService,
    private filtroSegmentacaoService: FiltroSegmentacaoService,
    private saldoService: SaldoService,
    public permissaoService: PermissaoService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef
  ) {}

  @ViewChild('swiper') swiperElement!: ElementRef<SwiperContainer>;

  abrangencia: ChaveValor[] = [];
  abrangenciaSelecionada: string = '';
  termoPesquisa: string = '';
  carregandoAbrangencia: boolean = true;
  novidades: Novidade[] = [];
  carregandoNovidades: boolean = true;
  novidadeSelecionada: Novidade | null = null;
  buscandoOportunidades: boolean = false;
  EnumPermissao = EnumPermissao;
  mostrarModalSemCreditos: boolean = false;
  mostrarModalBoasVindas: boolean = false;

  swiperParams = {};
  readonly slidesPerViewPadrao = 3;
  slideAtual = 0;
  totalSlides = 0;

  async ngOnInit() {
    await this.carregarNovidades();
    await this.carregarAbrangencia();
  }

  async ngAfterViewInit() {
    const primeiroAcesso = this.verificarPrimeiroAcesso();
    if (!primeiroAcesso) {
      await this.verificarSaldo();
    }
    this.cdr.detectChanges();
  }

  async verificarSaldo() {
    const modalExibido =
      localStorage.getItem('modalSemCreditosExibido') === 'true';
    const saldo = await this.saldoService.obterSaldoAtual();

    if (
      saldo.quantidade <= 0 &&
      !modalExibido
    ) {
      this.mostrarModalSemCreditos = true;
      localStorage.setItem('modalSemCreditosExibido', 'true');
    } else {
      this.mostrarModalSemCreditos = false;
    }
  }

  verificarPrimeiroAcesso(): boolean {
    const primeiroAcesso = this.authService.getPrimeiroAcesso();
    const modalExibido =
      localStorage.getItem('modalBoasVindasExibido') === 'true';
    if (primeiroAcesso && !modalExibido) {
      this.mostrarModalBoasVindas = true;
      localStorage.setItem('modalBoasVindasExibido', 'true');
    }

    return primeiroAcesso;
  }

  fecharModalSemCreditos() {
    this.mostrarModalSemCreditos = false;
  }

  fecharModalBoasVindas() {
    this.mostrarModalBoasVindas = false;
  }

  private async carregarAbrangencia(): Promise<void> {
    try {
      this.carregandoAbrangencia = true;
      const data = await this.homeService.listarFiltroAbrangencia();
      this.abrangencia = data;
      this.abrangenciaSelecionada = this.abrangencia[0].valor;
    } finally {
      this.carregandoAbrangencia = false;
    }
  }

  private async carregarNovidades(): Promise<void> {
    try {
      this.carregandoNovidades = true;
      const response = await this.homeService.listarNovidades(10, 1);
      this.novidades = response.novidades;
      this.configurarSwiper(response.totalNovidades);
    } catch (error) {
      console.error('Erro ao carregar novidades:', error);
      this.toastr.error('Erro ao carregar novidades');
      this.novidades = [];
    } finally {
      this.carregandoNovidades = false;
    }
  }

  async buscarOportunidades() {
    if (!this.permissaoService.canFazerSegmentacao()) {
      this.toastr.warning('Você não tem permissão para fazer segmentação');
      return;
    }

    const temSaldo = await SaldoUtil.validarAcessoSegmentacao(
      this.saldoService,
      this.router,
      this.toastr
    );
    if (!temSaldo) {
      return;
    }

    if (
      !this.abrangenciaSelecionada ||
      this.abrangenciaSelecionada.length == 0
    ) {
      this.toastr.warning('Selecione uma abrangência');
      return;
    }

    try {
      this.buscandoOportunidades = true;
      const filtro: FiltroSegmentacao = {
        abrangencia: [this.abrangenciaSelecionada]
      };
      this.filtroSegmentacaoService.atualizarFiltro(filtro);
      this.router.navigate(['/area-logada/segmentacao']);
    } finally {
      this.buscandoOportunidades = false;
    }

  }

  async buscarOportunidadesOld() {
    if (!this.permissaoService.canFazerSegmentacao()) {
      this.toastr.warning('Você não tem permissão para fazer segmentação');
      return;
    }

    const temSaldo = await SaldoUtil.validarAcessoSegmentacao(
      this.saldoService,
      this.router,
      this.toastr
    );
    if (!temSaldo) {
      return;
    }

    if (!this.validarPesquisa()) {
      return;
    }

    try {
      this.buscandoOportunidades = true;
      const response = await this.homeService.buscarOportunidades(
        [this.abrangenciaSelecionada],
        this.termoPesquisa
      );
      if (response.possuiRegistros) {
        this.toastr.success(
          'Dados encontrados, redirecionando para a página de segmentação'
        );
        setTimeout(() => {
          this.filtroSegmentacaoService.atualizarFiltro(response.filtro);
          this.router.navigate(['/area-logada/segmentacao']);
        }, 1000);
      } else {
        this.toastr.warning(
          `Sua pesquisa não gerou resultados na(s) abrangência(s) selecionada(s) ${this.abrangenciaSelecionada}. Por favor, tente uma nova expressão.`
        );
      }
    } finally {
      this.buscandoOportunidades = false;
    }
  }

  validarPesquisa() {
    let valido = true;
    if (
      !this.abrangenciaSelecionada ||
      this.abrangenciaSelecionada.length == 0
    ) {
      this.toastr.warning('Selecione uma abrangência');
      valido = false;
    }

    if (this.termoPesquisa.length <= 10) {
      this.toastr.warning('Por favor, informe o termo de pesquisa');
      valido = false;
    }

    if (this.termoPesquisa && this.termoPesquisa.length > 300) {
      this.toastr.warning(
        'O termo de pesquisa deve ter entre 10 e 300 caracteres'
      );
      valido = false;
    }

    return valido;
  }

  selecionarNovidade(novidade: any) {
    this.novidadeSelecionada = novidade;
  }

  fecharModal() {
    this.novidadeSelecionada = null;
  }

  visualizarOportunidades(filtro?: string | undefined) {
    try {
      const filtroConvertido = JSON.parse(filtro ?? '{}');

      this.filtroSegmentacaoService.atualizarFiltro({
        ...filtroConvertido,
      });

      this.router.navigate(['/area-logada/segmentacao']);
    } catch (error) {
      console.error('Erro ao visualizar oportunidades:', error);
      this.toastr.error('Erro ao visualizar oportunidades');
    }
  }

  private configurarSwiper(totalNovidades: number) {
    if (totalNovidades <= 0) {
      return;
    }
    this.slideAtual = 0;
    this.totalSlides = Math.ceil(totalNovidades / this.slidesPerViewPadrao);

    this.swiperParams = {
      slidesPerView: Math.min(this.slidesPerViewPadrao, totalNovidades),
      loop: false,
      enabled: true,
      allowTouchMove: false,
      touchStartPreventDefault: true,
      simulateTouch: false,
      touchEventsTarget: 'wrapper',
      preventInteractionOnTransition: true,
      spaceBetween: 24,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: Math.min(1, totalNovidades),
          spaceBetween: 10,
        },
        480: {
          slidesPerView: Math.min(2, totalNovidades),
          spaceBetween: 20,
        },
        768: {
          slidesPerView: Math.min(3, totalNovidades),
          spaceBetween: 24,
        },
      },
    };

    setTimeout(() => {
      if (!this.swiperElement?.nativeElement) {
        return;
      }

      const swiperEl = this.swiperElement.nativeElement;

      Object.assign(swiperEl, this.swiperParams);
      swiperEl.initialize();

      if (swiperEl.swiper) {
        swiperEl.swiper.wrapperEl.style.justifyContent = 'center';
        swiperEl.swiper.allowTouchMove = false;
        swiperEl.swiper.update();
      }
    }, 100);
  }
  proximoSlide() {
    if (this.swiperElement?.nativeElement?.swiper) {
      const swiper = this.swiperElement.nativeElement.swiper;

      if (this.slideAtual < this.totalSlides - 1) {
        this.slideAtual++;
        swiper.slideNext();
      }
    }
  }

  anteriorSlide() {
    if (this.swiperElement?.nativeElement?.swiper) {
      const swiper = this.swiperElement.nativeElement.swiper;

      if (this.slideAtual > 0) {
        this.slideAtual--;
        swiper.slidePrev();
      }
    }
  }

  podeNavegarProximo(): boolean {
    return this.slideAtual < this.totalSlides - 1;
  }

  podeNavegarAnterior(): boolean {
    return this.slideAtual > 0;
  }
}
